export function isInvernestDomain(): boolean {
  const { hostname } = new URL(window.location.href)
  if (hostname.includes('invernest') || hostname.includes('localhost')) {
    return true
  }
  return false
}
